import React from "react";

export default function SegmentedControl({ value, onChange, options = [], columnsClass = "grid-cols-2" }) {
  return (
    <div className={`segmented-shell ${columnsClass}`}>
      {options.map((item) => (
        <button
          key={item.value}
          type="button"
          onClick={() => onChange(item.value)}
          className={`segmented-btn ${value === item.value ? "segmented-btn-active" : ""}`}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
